/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import "./identification-and-verification.scss";
import {
  RA_STEPS_IDENTIFIERS,
  IDV_DURATION,
  WORK_ITEM_TYPE,
} from "../../constants/constants";
import { Icons } from "../../atoms/Icons";
import { verificationListData } from "../../data/verificationListData";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import { GBGMessage } from "../../constants/constants";
import LoadingSpinner from "../../atoms/Loader";

const IdentificationAndVerification = (props) => {
  const dataIntervalRef = useRef();
  const dataTimeoutRef = useRef();

  const [QRcodeBase64, setQRcodeBase64] = useState("");
  const [QRcodeURL, setQRcodeURL] = useState("");
  const { data: accData } = useSelector((state) => state.account);
  const [clickedNext, setClickedNext] = useState(false);
  const dispatch = useDispatch();
  const { retirementIdentity, RetirementQr, getAccountPageContent } =
    bindActionCreators(
      actionCreators,
      dispatch // eslint-disable-line
    );
  useEffect(() => {
    getAccountPageContent(props.investorId);
    window.scrollTo(0, 0);
  }, []);

  const { bankDetails } = useSelector(
    (state) => state.retirementApplication, // eslint-disable-line
  );
  const { data: dataPatch } = useSelector((state) => state.retirementQr);
  const investorId = props?.investorId;
  const retirementId = props?.retirementId;
  const bankAccType = bankDetails?.swift ? "International" : "Domestic";

  useEffect(() => {
    const hasPersonalDetails = accData?.givenNames && accData?.name;

    const hasAddressDetails =
      accData?.address?.propertyName ||
      accData?.address?.streetNumber ||
      accData?.address?.street ||
      accData?.address?.street2 ||
      accData?.address?.town ||
      accData?.address?.county ||
      accData?.address?.postCode ||
      accData?.address?.countryCode ||
      accData?.countryName?.option;

    if (hasPersonalDetails && hasAddressDetails) {
      const payload = {
        journeyRequest: {
          investorId: parseInt(investorId),
          retirementId: retirementId,
          workItemType: WORK_ITEM_TYPE?.WORK_ITEM_RETIREMENT_BANK,
          updatedFields: Object.keys(bankDetails)
            .filter((key) => bankDetails[key] !== "")
            .map((key) => key.replace("Value", ""))
            .join(","),
        },
        userInfo: {
          perosnalDetails: {
            firstName: accData?.givenNames,
            lastName: accData?.name,
          },
          addressDetails: {
            propertyName: accData?.address?.propertyName,
            propertyNumber: accData?.address?.streetNumber,
            street: accData?.address?.street,
            street2: accData?.address?.street2,
            town: accData?.address?.town,
            county: accData?.address?.county,
            postCode: accData?.address?.postCode,
            countryCode: accData?.address?.countryCode,
            country: accData?.countryName?.option,
          },
          bankDetails: {
            accountName: bankDetails?.accountName,
            accountType: bankAccType,
            accountNumber: bankDetails?.accountNumber,
            ...(bankDetails?.swift
              ? { swift: bankDetails?.swift }
              : { sortCode: bankDetails?.sortCodeVal }),
            ...(bankDetails?.societyCode
              ? { societyCode: bankDetails?.societyCode }
              : {}),
          },
        },
      };
      RetirementQr(props.investorId, payload);
    }
  }, [bankDetails, accData]);

  useEffect(() => {
    if (dataPatch?.data?.QR_Code) {
      setQRcodeBase64("data:image/png;base64," + dataPatch?.data?.QR_Code);
      setQRcodeURL(dataPatch?.data?.URL);
    }
  }, [dataPatch]);

  const handleBack = () => {
    props.makeInitialStepper(true);
  };
  const sacj = false;
  const handleContinue = () => {
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION, // eslint-disable-line
    );
  };
  return (
    <>
      {!dataPatch?.message ? (
        <Card className="application-step">
          <LoadingSpinner class />
        </Card>
      ) : dataPatch?.message === GBGMessage.GBG_FAILED &&
        clickedNext === false ? (
        <Card className="application-step">
          <Card.Body className="identificationa-and-verification">
            <p className="gbg-fail-text">
              Unfortunately, our initial checks haven&apos;t been able to verify
              that your bank details belong to you. We are only able to pay your
              retirement funds into a bank account where you are the named
              account holder or joint account holder. We just need to ask for a
              bit more information for us to progress.
            </p>
            <p className="gbg-fail-text">
              In order to verify your account, in the screens that follow,
              firstly please help us check your identity by taking a photo of
              either your passport, driver&apos;s license or other photo
              identity card, and a selfie to check it is you making the request.
              Then, on the third screen please take a picture of your bank
              statement. Your statement will need to clearly show your name,
              address and account details. As long as those details are visible
              and your name and address are the same as the ones we hold on file
              for you, then we&apos;ll use that account to pay your benefits. If
              they aren&apos;t easily viewed we&apos;ll contact you to use
              another means of verification.{" "}
            </p>
            <p className="gbg-fail-text">
              Please note that we will use the bank statement photo, not the
              details you have just entered if they happen to be different, to
              make payment so make sure the statement you photograph is the
              account you want your savings to be paid into.
            </p>
            <Col className="text-end">
              <Buttons
                className="primary "
                name="Next"
                handleClick={() => {
                  setClickedNext(true);
                }}
              />
            </Col>
          </Card.Body>
        </Card>
      ) : (
        <Card className="application-step">
          <Card.Body className="identificationa-and-verification">
            <Row>
              <Col md={12} className="mb-fourty">
                <p className="guidance ">Identification and verification</p>
              </Col>
            </Row>
            <Row className="ourter-bg">
              <Col md={7} className="bg-text">
                <p>
                  To keep your pension secure, we will now check that we are
                  paying this pension to you, the account holder, and that your
                  bank details match those you have entered.
                </p>
                <p>
                  Please have a mobile phone, photo ID (passport or driver’s
                  licence) and a recent bank statement in your name. If we need
                  any more details, we’ll contact you with further instructions.
                </p>
              </Col>
            </Row>

            <Row className="justify-content-evenly qr-body-section">
              <Col lg={5} className="mt-5 pe-0">
                <p className="qr-body-heading">You will need</p>
                {verificationListData?.map((item, index) => {
                  return (
                    <Row key={index} className="qr-card mb-3">
                      <Col
                        lg={2}
                        sm={2}
                        xs={2}
                        className="d-none d-lg-block d-xs-none d-md-none d-sm-none p-0"
                      >
                        {" "}
                        <Icons
                          iconname={item.icon}
                          variant="icon-fourty-eight-px"
                        />
                      </Col>
                      <Col
                        lg={2}
                        sm={2}
                        xs={2}
                        className="d-block d-lg-none d-xs-block d-md-block d-sm-block"
                      >
                        {" "}
                        <Icons
                          iconname={item.icon}
                          variant="icon-thirty-two-px"
                        />
                      </Col>
                      <Col
                        lg={10}
                        sm={10}
                        xs={10}
                        className="p-0 ps-2 p-span-text-wrapper"
                      >
                        <p>{item.title}</p>
                        <span>{item.subTitle}</span>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
              <Col
                lg={4}
                className="d-none d-lg-block d-xs-none d-md-block d-sm-none mt-5 text-center scanner-card"
              >
                <Card className="qr-scanner">
                  <Card.Footer className="Scan-to-continue-text">
                    <div className="qrcode-img">
                      <img src={QRcodeBase64} />
                    </div>
                    Scan to continue
                  </Card.Footer>
                </Card>
                <span className="qr-text">
                  Please use a smart phone camera or QR code reader to scan this
                  code and start the checks.
                </span>
              </Col>
              <Col className="d-block d-lg-none d-xs-block d-md-none d-sm-block mt-4">
                <p className="exp-text">
                  Experience will launch in a new window
                </p>
                <Buttons
                  className="primary"
                  name="Continue"
                  handleClick={() => {
                    window.open(QRcodeURL, "_blank"); //to open new window
                  }}
                />
              </Col>
            </Row>

            <div className="footer-btn-container">
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />

              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
              />
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
export default IdentificationAndVerification;
